export const collages = [
    {
      "collageName": "Olds College",
      "City": "Olds",
      "Country": "Canada"
    },
    {
      "collageName": "Medicine Hat College (MHC)",
      "City": "Medicine Hat",
      "Country": "Canada"
    },
    {
      "collageName": "Norquest College",
      "City": "Edmonton",
      "Country": "Canada"
    },
    {
      "collageName": "City University (CityU)",
      "City": "Calgary",
      "Country": "Canada"
    },
    {
      "collageName": "University of Calgary (Ucal)",
      "City": "Calgary",
      "Country": "Canada"
    },
    {
      "collageName": "Lasalle College vancouver",
      "City": "Vancouver",
      "Country": "Canada"
    },
    {
      "collageName": "Alexander College",
      "City": "Vancouver",
      "Country": "Canada"
    },
    {
      "collageName": "Coquitlam College",
      "City": "Surrey",
      "Country": "Canada"
    },
    {
      "collageName": "University Canada West",
      "City": "Vancouver",
      "Country": "Canada"
    },
    {
      "collageName": "Trinity western university (TWU)",
      "City": "Langlay",
      "Country": "Canada"
    },
    {
      "collageName": "Justice institute of British coloumbia",
      "City": "Vancouver",
      "Country": "Canada"
    },
    {
      "collageName": "Adler University",
      "City": "Vancouver",
      "Country": "Canada"
    },
    {
      "collageName": "New York Institute of Technology (NYIT)",
      "City": "Vancouver",
      "Country": "Canada"
    },
    {
      "collageName": "Ontario Tech University (OTU)",
      "City": "Oshawa",
      "Country": "Canada"
    },
    {
      "collageName": "Niagara University (NU)",
      "City": "Vaughan",
      "Country": "Canada"
    },
    {
      "collageName": "University of Niagara Falls (UNF)",
      "City": "Niagara Falls",
      "Country": "Canada"
    },
    {
      "collageName": "Queens University",
      "City": "Kingston",
      "Country": "Canada"
    },
    {
      "collageName": "Toronto School of Management (TSoM)",
      "City": "Toronto",
      "Country": "Canada"
    },
    {
      "collageName": "Canadian college of technology & business (CCTB)",
      "City": "Vancouver",
      "Country": "Canada"
    },
    {
      "collageName": "Access College Riverside",
      "City": "Saint-Hubert",
      "Country": "Canada"
    },
    {
      "collageName": "Sir wilfrid Laurier School Board-CDC",
      "City": "Laval",
      "Country": "Canada"
    },
    {
      "collageName": "Vanier College",
      "City": "Montreal",
      "Country": "Canada"
    },
    {
      "collageName": "Lasalle College Montreal",
      "City": "Montreal",
      "Country": "Canada"
    },
    {
      "collageName": "Canada College",
      "City": "Montreal",
      "Country": "Canada"
    },
    {
      "collageName": "Cester College",
      "City": "Montreal",
      "Country": "Canada"
    },
    {
      "collageName": "Tav College",
      "City": "Montreal",
      "Country": "Canada"
    },
    {
      "collageName": "Aviron College",
      "City": "Montreal",
      "Country": "Canada"
    },
    {
      "collageName": "Southeast College (SE)",
      "City": "Wayburn",
      "Country": "Canada"
    },
    {
      "collageName": "University of Regina (Uregina)",
      "City": "Saskatchewan",
      "Country": "Canada"
    },
    {
      "collageName": "Dalhousie University",
      "City": "Halifax",
      "Country": "Canada"
    },
    {
      "collageName": "Georgian College",
      "City": "Barrie",
      "Country": "Canada"
    },
    {
      "collageName": "Malta Facilities Management Academy and Consultancy (MFMAC)",
      "City": "Malta",
      "Country": "Canada"
    },
    {
      "collageName": "La Vallette Institute",
      "City": "Malta",
      "Country": "Canada"
    },
    {
      "collageName": "Malita International College,",
      "City": "Malta",
      "Country": "Canada"
    },
    {
      "collageName": "International Institute",
      "City": "Malta",
      "Country": "Canada"
    },
    {
      "collageName": "Saskatchewan Polytechnic College",
      "City": "SK",
      "Country": "Canada"
    },
    {
      "collageName": "Concordia College",
      "City": "Edmonton",
      "Country": "Canada"
    },
    {
      "collageName": "Langara College",
      "City": "Vancouver",
      "Country": "Canada"
    }
  ];